webpackJsonp([915738553496],{

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(8);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _Main = __webpack_require__(40);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Article = __webpack_require__(39);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _PageHeader = __webpack_require__(45);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(44);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Footer = __webpack_require__(104);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {};
	};
	
	var Support = function Support() {
	  return _react2.default.createElement(
	    _Main2.default,
	    null,
	    _react2.default.createElement(
	      _Article2.default,
	      null,
	      _react2.default.createElement(_PageHeader2.default, { title: "Privacy Policy" }),
	      _react2.default.createElement(
	        _Content2.default,
	        null,
	        _react2.default.createElement("hr", { "class": "section-divider" }),
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Privacy Policy"
	        ),
	        _react2.default.createElement(
	          "p",
	          { "class": "meta" },
	          "Effective Date: August 21, 2024 \xA0\xB7\xA0 Last Updated: June 5, 2026 \xA0\xB7\xA0 Site: ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.projectsurfhelmet.com" },
	            "projectsurfhelmet.com"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { "class": "highlight-box" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "The short version:"
	          ),
	          " This is a personal hobby site. I don't collect much. I don't sell anything. StatCounter tracks anonymized site traffic. Affiliate links set retailer cookies I don't control. Cookie consent is managed through Cookiebot. If you're in the EU, California, Canada, or Australia \u2014 your rights are covered below. Questions? Email me."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "1. Who I Am (Data Controller)"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Project Surf Helmet (projectsurfhelmet.com) is a personal hobby site operated by one individual. I am not a company. For the purposes of privacy law, I am the sole data controller for any personal information processed through this site."
	        ),
	        _react2.default.createElement(
	          "div",
	          { "class": "contact-block" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Cole Merrick"
	          ),
	          " \u2014 Personal hobby site operator",
	          _react2.default.createElement("br", null),
	          "Long Beach, CA, USA",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:cole@projectsurfhelmet.com" },
	            "cole@projectsurfhelmet.com"
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "2. What Data I Collect and Why"
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Analytics"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "This site uses ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            "StatCounter"
	          ),
	          " to understand traffic patterns \u2014 which pages are popular, roughly where visitors come from, and how the site is used. StatCounter collects anonymized data including IP addresses (which StatCounter may use to derive approximate location), browser type, and pages visited. I do not use this data to identify individual visitors."
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Cookies & Consent Management"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Cookie consent on this site is managed through ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Cookiebot"
	          ),
	          ", which gives you granular control over which cookies you allow before they are set. The site uses the following types of cookies:"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Necessary cookies"
	            ),
	            " \u2014 Required for the site to function (including Cookiebot's own consent cookie, which remembers your preferences)."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Statistics cookies"
	            ),
	            " \u2014 Set by StatCounter to track anonymized visit patterns."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Affiliate cookies"
	            ),
	            " \u2014 When you click an affiliate link (e.g., to Amazon), the retailer sets a cookie to attribute any resulting purchase so I can receive a small commission. I do not set or control these cookies \u2014 they are governed by the retailer's own privacy policy."
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "You can change or withdraw your cookie consent at any time via the cookie banner on this site, or by adjusting your browser settings. Withdrawing consent for statistics cookies does not affect your ability to read the site."
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Contacting Me"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "The only way to contact me directly is by email:",
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:cole@projectsurfhelmet.com" },
	            "cole@projectsurfhelmet.com"
	          ),
	          ". There is no contact form. If you email me, I receive your email address and message. I use this only to reply to you and do not share it with anyone."
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Affiliate Links"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Clicking an affiliate link on this site may pass a referral identifier to the linked retailer (e.g., Amazon). What that retailer does with that data is governed by their privacy policy, not mine."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "3. What I Do NOT Do"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            "I do not sell your personal information \u2014 ever."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "I do not run advertising networks or serve behaviorally targeted ads."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "I do not build personal profiles of visitors."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "I do not send marketing emails."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "I do not collect payment information."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "I do not have user accounts or registration."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "I do not collect sensitive data (no SSNs, financial details, health data, etc.)."
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "4. Third-Party Services"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "The following third-party services may collect data independently per their own policies:"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "StatCounter"
	            ),
	            " \u2014 Anonymized analytics.",
	            _react2.default.createElement(
	              "a",
	              { href: "https://statcounter.com/about/legal/", target: "_blank", rel: "noopener" },
	              "StatCounter Privacy Policy"
	            ),
	            ". You can opt out at",
	            " ",
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://statcounter.com/about/set-refusal-cookie/",
	                target: "_blank",
	                rel: "noopener"
	              },
	              "statcounter.com/about/set-refusal-cookie"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Cookiebot (Usercentrics)"
	            ),
	            " \u2014 Cookie consent management.",
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.cookiebot.com/en/privacy-policy/", target: "_blank", rel: "noopener" },
	              "Cookiebot Privacy Policy"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Amazon Associates and other affiliate programs"
	            ),
	            " \u2014 Governed by the respective retailer's privacy policy when you click through."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Site hosting / CDN providers"
	            ),
	            " \u2014 May log standard server access data (IP addresses, browser type, access times) for security and operational purposes."
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "5. Your Rights"
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "EU / EEA / UK Residents (GDPR & UK GDPR)"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Under the General Data Protection Regulation (GDPR) and UK GDPR, you have the right to:"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Access"
	            ),
	            " \u2014 Request a copy of personal data I hold about you."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Rectification"
	            ),
	            " \u2014 Request correction of inaccurate data."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Erasure"
	            ),
	            " \u2014 Request deletion of your personal data (\"right to be forgotten\")."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Restriction"
	            ),
	            " \u2014 Request that I limit how I process your data."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Objection"
	            ),
	            " \u2014 Object to processing based on legitimate interests."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Portability"
	            ),
	            " \u2014 Request your data in a portable format."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Withdraw consent"
	            ),
	            " \u2014 Where processing is based on consent, you may withdraw it at any time without affecting the lawfulness of prior processing."
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "My legal basis for analytics processing is ",
	          _react2.default.createElement(
	            "em",
	            null,
	            "consent"
	          ),
	          " (via Cookiebot, before StatCounter cookies are set). For email correspondence, the legal basis is",
	          _react2.default.createElement(
	            "em",
	            null,
	            "performance of a request"
	          ),
	          " (responding to your message)."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "You also have the right to lodge a complaint with your local data protection authority (e.g., the ICO in the UK, or your EU member state's DPA)."
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "California Residents (CCPA / CPRA)"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Under the California Consumer Privacy Act (CCPA) and CPRA, you have the right to:"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            "Know what personal information is collected about you and how it is used."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Request deletion of your personal information."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Opt out of the sale of personal information \u2014",
	            " ",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "note: I do not sell personal information."
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Non-discrimination for exercising any of these rights."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            "Correct inaccurate personal information I hold about you."
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "To exercise these rights, contact:",
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:cole@projectsurfhelmet.com" },
	            "cole@projectsurfhelmet.com"
	          ),
	          ". I will respond within 45 days."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "If you have an unresolved complaint, you may contact the California Department of Consumer Affairs at 1625 North Market Blvd, Suite N 112, Sacramento, CA 95834 / (800) 952-5210."
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Canadian Residents (PIPEDA)"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Under Canada's Personal Information Protection and Electronic Documents Act (PIPEDA), you have the right to access the personal information I hold about you and to request corrections. Contact me at",
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:cole@projectsurfhelmet.com" },
	            "cole@projectsurfhelmet.com"
	          ),
	          " to make a request."
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Australian Residents (Australian Privacy Act 1988)"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Under the Australian Privacy Act 1988 and the Australian Privacy Principles (APPs), you have the right to access and seek correction of personal information I hold about you. You also have the right to complain to the Office of the Australian Information Commissioner (OAIC) if you believe your privacy rights have been breached. Contact me first at ",
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:cole@projectsurfhelmet.com" },
	            "cole@projectsurfhelmet.com"
	          ),
	          "."
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Brazilian Residents (LGPD)"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Under Brazil's Lei Geral de Prote\xE7\xE3o de Dados (LGPD), you have rights of access, correction, anonymization, portability, and deletion of your personal data. Contact me at ",
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:cole@projectsurfhelmet.com" },
	            "cole@projectsurfhelmet.com"
	          ),
	          " to make a request."
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "All Other Visitors"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Regardless of where you live, I aim to handle any personal data responsibly and minimally. If you have any concerns about your data, email me and I will do my best to address them."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "6. Data Retention"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Analytics data"
	            ),
	            " \u2014 Retained per the analytics provider's default retention settings (typically 14\u201326 months for Google Analytics)."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Contact form messages"
	            ),
	            " \u2014 Retained until the correspondence is resolved, then deleted."
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Server logs"
	            ),
	            " \u2014 Retained briefly by hosting infrastructure for security purposes, then automatically purged."
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "7. Data Security"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "I take reasonable precautions to protect data, including using HTTPS and secure hosting. However, no internet transmission is 100% secure. Please do not send sensitive personal information through this site's contact form."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "8. International Data Transfers"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "This site is hosted in the United States. If you are visiting from outside the US, your data may be transferred to and processed in the US. Third-party services (e.g., Google Analytics) may also transfer data internationally per their own data transfer mechanisms (e.g., Standard Contractual Clauses for EU data)."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "9. Children's Privacy"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "This site is not directed at children under 13 (or under 16 for EU residents). I do not knowingly collect personal information from minors. If you believe a child has submitted data through this site, contact me and I will delete it promptly."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "10. Links to Other Sites"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "This site links to third-party websites. I am not responsible for the privacy practices of any external site. Review each site's own privacy policy before providing any personal information."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "11. Changes to This Policy"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "I may update this privacy policy at any time. The \"Last Updated\" date at the top of this page will reflect changes. For significant changes, I will make reasonable efforts to notify users (e.g., a notice on the site homepage)."
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "12. Contact & Rights Requests"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "To exercise any privacy rights, ask questions, or raise concerns about this policy:"
	        ),
	        _react2.default.createElement(
	          "div",
	          { "class": "contact-block" },
	          _react2.default.createElement(
	            "strong",
	            null,
	            "Cole Merrick"
	          ),
	          " \u2014 Project Surf Helmet",
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "a",
	            { href: "mailto:cole@projectsurfhelmet.com" },
	            "cole@projectsurfhelmet.com"
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          "Response times: within 30 days generally; 45 days for CCPA requests; one month for GDPR requests (extendable by two months for complex requests, with notice)."
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	Support.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(Support);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-js-337dbe4df81aa33ef4bd.js